import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { IS_MOCK } from './auth/useAuth';
import { AuthProvider } from './auth/AuthContext';
import { AuthGuard } from './auth/AuthGuard';

async function bootstrap() {
  if (!IS_MOCK) {
    const { MsalProvider } = await import('@azure/msal-react');
    const { msalInstance } = await import('./auth/msalConfig');
    // initialize() handles the redirect response on the way back from Microsoft login
    await msalInstance.initialize();

    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <AuthGuard>
              <App />
            </AuthGuard>
          </AuthProvider>
        </MsalProvider>
      </React.StrictMode>
    );
    return;
  }

  // Mock mode — no MSAL needed
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AuthProvider>
        <AuthGuard>
          <App />
        </AuthGuard>
      </AuthProvider>
    </React.StrictMode>
  );
}

void bootstrap();
